import React, { useState } from "react";
import { notifyError, notifySuccess, validateEmail } from "../helper";
import client from "../api";
import Header from "./Header";
import Footer from "./Footer";

const ForgetPasswordPage = () => {
    const api = client();
    const [forgetEmail, setForgetEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const submitForgetPassword = async () => {
        if(validateField(forgetEmail)){
            try{   
                setLoading(true);         
                const response = await api.post('/v1/user/forgotPassword',{
                    email:forgetEmail
                });
            
                if(response.status === 200 ||  response.status === 201){
                    notifySuccess('An email has been sent to the registered email address');
                    setLoading(false);
                    setTimeout(()=>{
                        setForgetEmail('');
                    },1000);
                    
                }
            } catch(error) {
                setLoading(false);
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to send email for password reset');
            }
        } 
        
    }

    const validateField = (email) => {
        setError('');
        if(!forgetEmail.length){
            setError('Email is required');
            return false;
        } else if(!validateEmail(forgetEmail)){
            setError('Invalid Email');
            return false;
        } else {
            return true;
        }
    }
    return(<>
        <Header/>
        <div className="login-page">
            <div className="login-block">
                <h2>Forgot Password</h2>
                <p>Enter the email address associated with your account and we'll send you a link to reset your password.</p>
                <div className="form-wrap">
                    <div className="field-wrap">
                        <label className="label">Email Address</label>
                        <div className="input-wrap">
                            <input 
                                type="email" 
                                name="user_email" 
                                placeholder="Email Address" 
                                value={forgetEmail}
                                onChange={(e)=>{
                                    setForgetEmail(e.target.value);
                                }}
                                onFocus={()=>{setError('')}}
                                onBlur={(e)=>{
                                    setError('');
                                    validateField(forgetEmail);
                                }}
                            />
                            {error && <span className="validation-error">{error}</span>}
                        </div>
                    </div>
                    <div className="button-wrap center">
                        <button 
                            type="button" 
                            name="forgetpassword-submit"
                            disabled={loading}
                            className={loading ? "submit-btn button--loading":"submit-btn"}   
                            onClick={()=>{
                                submitForgetPassword();
                            }}> 
                            <span className="button--text">Submit</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </>);
}

export default ForgetPasswordPage;